// API client for the Cloudflare Worker backend.
// Auth is a JWT stored in localStorage (replaces the Supabase session).

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000'
const TOKEN_KEY = 'eh_token'

export const getToken = () => localStorage.getItem(TOKEN_KEY)
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t)
export const clearToken = () => localStorage.removeItem(TOKEN_KEY)

async function api(method, path, body) {
  const token = getToken()
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  })

  let data = null
  try {
    data = await res.json()
  } catch {
    /* empty / non-JSON body */
  }

  if (!res.ok) {
    if (res.status === 401) clearToken()
    throw new Error((data && data.error) || 'Request failed')
  }
  return data
}

export const get = (path) => api('GET', path)
export const post = (path, body) => api('POST', path, body)
export const put = (path, body) => api('PUT', path, body)
export const patch = (path, body) => api('PATCH', path, body)
export const del = (path) => api('DELETE', path)
